import { style } from '@vanilla-extract/css';

export const iconContainer = style({
  backgroundColor: 'var(--background-color)',
  borderWidth: 'var(--border-width)',
  borderColor: 'var(--border-color)',
  borderStyle: 'var(--border-style)',
  borderRadius: 'var(--border-radius)',
  padding: 'var(--padding)',
  width: 'fit-content',
  height: 'auto',
  color: 'var(--fill)',
  boxSizing: 'content-box',
});
